import React, { useState } from "react";
import "./SelectPlan.scss";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { useHistory } from "react-router";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import SubscriptionStylingProvider from "../../components/SubscriptionStylingProvider/SubscriptionStylingProvider";
import { closeSubscriptionPage } from "../../subscriptionFunctions";
import SubscriptionPageWrapper, {
  SubscriptionPageContent,
} from "../../components/SubscriptionPageWrapper/SubscriptionPageWrapper";
import { SubscriptionContactSupportModal } from "../../modals/SubscriptionContactSupportModal/SubscriptionContactSupportModal";

interface Props {}

function SelectSubscriptionPlan(props: Props) {
  const [showContactSupportModal, setShowContactSupportModal] = useState(false);

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const history = useHistory();

  return (
    <SubscriptionPageWrapper>
      <SubscriptionPageContent
        className="select-plan"
        backButtonFunction={() =>
          closeSubscriptionPage(history, activeWorkspaceUuid)
        }
        backButtonText={
          <IDHFormattedMessage
            id="ws_back_to_application"
            defaultMessage="Back to application"
          />
        }
      >
        <SubscriptionStylingProvider
          sectionStylingModes={{ paywall: "indahash" }}
        >
          No select plan screen available
        </SubscriptionStylingProvider>
      </SubscriptionPageContent>

      {showContactSupportModal && (
        <SubscriptionContactSupportModal
          onClose={() => setShowContactSupportModal(false)}
        />
      )}
    </SubscriptionPageWrapper>
  );
}

export default SelectSubscriptionPlan;
